export const SWATCHES = 'color-picker-color-swatches';
export const SWATCH = 'color-picker-color-swatch';
export const SWATCH_TOOLTIP = 'color-picker-colors-swatch-tooltip';
export const ADD_CUSTOM_COLOR_BUTTON = 'color-picker-add-custom-color-button';
export const RESET_COLOR_BUTTON = 'color-picker-reset-button';
